import { TZDate } from "@date-fns/tz";
import { format } from "date-fns";
import { GiftValidationType } from "../schemas/product.schema";

export const computeValidationDate = (
  invoiceDate: Date,
  giftValidationType: GiftValidationType | string | null,
): Date => {
  const expirationDate = new Date(invoiceDate);

  if (giftValidationType === GiftValidationType.THREE_MONTHS) {
    expirationDate.setMonth(expirationDate.getMonth() + 3);
  } else if (giftValidationType === GiftValidationType.SIX_MONTHS) {
    expirationDate.setMonth(expirationDate.getMonth() + 6);
  } else if (giftValidationType === GiftValidationType.ONE_YEAR) {
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
  } else {
    // Default to 1 year
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
  }

  return expirationDate;
};

export const formatDisplayDate = (date: Date): string => {
  return format(new TZDate(date, "Europe/Paris"), "dd/MM/yyyy");
};

export const formatDisplayLongDate = (date: Date, locale: string = "fr-FR"): string => {
  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "Europe/Paris",
  }).format(new TZDate(date, "Europe/Paris"));
};

export const formatDisplayTime = (date: Date): string => {
  return format(new TZDate(date, "Europe/Paris"), "HH:mm");
};

export const formatDisplayDateTime = (date: Date): string => {
  if (formatDisplayTime(date) === "00:00") {
    return format(
      new TZDate(date, "Europe/Paris"),
      "dd/MM/yyyy 'Billet journalier'",
    );
  }
  return format(new TZDate(date, "Europe/Paris"), "dd/MM/yyyy HH:mm");
};

/**
 * Format user-friendly pour le récap panier
 * - Billet journalier: "Mercredi 11 février 2026"
 * - Créneau horaire: "Mercredi 11 février 2026 à 09:00"
 *
 * Note: Un billet journalier est détecté si:
 * - L'heure en Europe/Paris est 00:00, OU
 * - L'heure UTC est 00:00 (date stockée au format "YYYY-MM-DD" sans heure)
 */
export const formatCartEventDate = (dateString: string, locale: string = "fr-FR", atWord: string = "à"): string => {
  const date = new Date(dateString);
  const longDate = formatDisplayLongDate(date, locale);
  // Capitalize first letter
  const capitalizedDate = longDate.charAt(0).toUpperCase() + longDate.slice(1);

  const time = formatDisplayTime(date);
  // Vérifie si c'est minuit en Europe/Paris OU minuit UTC (date sans composant horaire)
  const isDateOnly =
    date.getUTCHours() === 0 &&
    date.getUTCMinutes() === 0 &&
    date.getUTCSeconds() === 0;

  if (time === "00:00" || isDateOnly) {
    return capitalizedDate;
  }
  return `${capitalizedDate} ${atWord} ${time}`;
};
